import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

import ability, { EDIT, PUBLISH_PROJECT } from '../../../../common/ability';

function InfoMessage({ isTrialAccount }) {
  const infoMessage = (
    <div className='c-message is-note-subtle c-message--large'>
      <p className='c-message__description'>
        <strong>Trial Account</strong>
        <br />
        With a trial account you can preview how to set up your project, see first-hand how a survey would look to your
        community members and better understand the capabilities of Give My View.
        <br />
        <strong>You will not be able to activate this project and make it available to the public.</strong>
      </p>
    </div>
  );

  return isTrialAccount ? infoMessage : null;
}

function ProjectStatusToggle(props) {
  const { Store } = props;

  /**
   * Demo accounts https://github.com/sdesregistry/IH-Engage/issues/2396
   */
  const canPublish = !ability.can(EDIT, PUBLISH_PROJECT);

  const onChange = (event) => {
    Store.setProjectVisibility(event.target.checked);
  };

  return (
    <form className='c-fields c-fields--modern l-form' data-testid='project-status-toggle-wrapper'>
      <div className='c-field c-field--modern c-field--large l-form__item'>
        <label className='c-field__label'>Project status</label>

        <InfoMessage isTrialAccount={canPublish} />

        <div className='c-field__group'>
          <div className='o-checkbox o-checkbox--toggle is-danger'>
            <input
              type='checkbox'
              id='checkbox-project-status'
              value={Store.publishStatus.isProjectActive}
              onChange={onChange}
              checked={Store.publishStatus.isProjectActive}
              disabled={canPublish}
            />
            <label htmlFor='checkbox-project-status'>
              {Store.publishStatus.isProjectActive ? 'Active' : 'Inactive'}
            </label>
          </div>
          <p className='c-field__description'>
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            Projects can be <strong>active</strong> or <strong>inactive</strong>. Inactive projects won't be visible to
            the community.
          </p>
        </div>
      </div>
    </form>
  );
}

ProjectStatusToggle.propTypes = {
  Store: PropTypes.object.isRequired,
};

export default inject((root) => ({ Store: root.RootStore.projectControlStore }))(observer(ProjectStatusToggle));
